module.exports = __webpack_public_path__ + "img/sire-icon.2cb6402b.svg";